import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-practical-batch',
  templateUrl: './practical-batch.component.html',
  styleUrls: ['./practical-batch.component.scss']
})
export class PracticalBatchComponent implements OnInit {

  batchArray: any[] = [];
  totalStudents: number = 0;
  originalBatchCnt: number = 0;
  originalTotalStudents: number = 0;
  batchSize: number = 0;

  constructor(
    public dialogRef: MatDialogRef<PracticalBatchComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    const batchCnt = this.data.batchCnt || 1;

    this.totalStudents = Number(this.data.totalStudents) || 0;
    this.batchSize = Number(this.data.batchSize) || 0;

    this.originalBatchCnt = batchCnt;
    this.originalTotalStudents = this.totalStudents;

    const hasValidPrefill =
      this.data.batchDetails &&
      this.data.batchDetails.length === batchCnt;

    if (hasValidPrefill) {
      this.batchArray = this.data.batchDetails.map((batch: any) => ({
        batchNo: batch.batchNo,
        batchName: batch.batchName || '',
        studCnt: Number(batch.studCnt) || 0,
        assigned: batch.assigned !== undefined ? batch.assigned : true
      }));
      this.distributeStudents();
    } else {
      this.createNewBatches(batchCnt);
    }
  }

  createNewBatches(batchCnt: number) {
    this.batchArray = Array.from({ length: batchCnt }, (_, i) => ({
      batchNo: i + 1,
      batchName: '',
      studCnt: 0,
      assigned: true
    }));
    this.distributeStudents();
  }

  distributeStudents() {
    this.batchArray.forEach(batch => batch.studCnt = 0);

    const activeBatches = this.batchArray.filter(b => b.assigned);

    if (activeBatches.length === 0) {
      return;
    }

    let remainingStudents = Number(this.totalStudents);
    const batchSizeNum = Number(this.batchSize);

    for (let i = 0; i < activeBatches.length; i++) {
      const batch = activeBatches[i];
      
      if (remainingStudents <= 0) {
        batch.studCnt = 0;
        continue;
      }

      if (i === activeBatches.length - 1) {
        batch.studCnt = remainingStudents;
      } else {
        const assignCount = Math.min(batchSizeNum, remainingStudents);
        batch.studCnt = assignCount;
        remainingStudents = remainingStudents - assignCount;
      }
    }
  }

  onCheckboxChange() {
    this.distributeStudents();
  }

  getAssignCount(): number {
    return this.batchArray.filter(b => b.assigned).length;
  }

  isValid(): boolean {
    const assignedBatches = this.batchArray.filter(b => b.assigned);

    const allHaveNames = assignedBatches.every(b =>
      b.batchName && b.batchName.trim().length > 0
    );

    if (!allHaveNames) {
      return false;
    }

    const batchNames = assignedBatches
      .map(b => b.batchName.trim().toLowerCase())
      .filter(name => name.length > 0);

    return batchNames.length === new Set(batchNames).size;
  }

  isDuplicateName(index: number): boolean {
    const currentBatch = this.batchArray[index];

    if (!currentBatch.assigned || !currentBatch.batchName?.trim()) {
      return false;
    }

    const currentName = currentBatch.batchName.trim().toLowerCase();

    return this.batchArray.some((batch, i) =>
      i !== index &&
      batch.assigned &&
      batch.batchName &&
      batch.batchName.trim().toLowerCase() === currentName
    );
  }

  hasDuplicateNames(): boolean {
    return this.batchArray.some((_, i) => this.isDuplicateName(i));
  }

  save() {
    if (!this.isValid()) {
      return;
    }

    this.distributeStudents();

    this.dialogRef.close({
      batchDetails: this.batchArray,
      assignCnt: this.getAssignCount()
    });
  }

  close() {
    this.dialogRef.close(null);
  }
}